export default "__VITE_ASSET__af500927__"